<template>
  <div>
    <div class="card-video">
      <img class="thumbnail-video" :alt="video.titulo" :src="img_url" />
      <div class="dercricao-video">
        <h1>{{ video.titulo }}</h1>
        <b-tooltip class="rigth" label="Assitir" position="is-top" type="is-dark">
          <button class="button is-primary is-round" id="info" @click="isCardModalActive = true">
            <b-icon icon="eye"></b-icon>
          </button>
        </b-tooltip>
        <h2>{{ video.descricao }}</h2>
        <b-taglist>
          <b-tag type="is-info tag-video" v-for="tag in video.tags" :key="tag.id">{{ tag.nome }}</b-tag>
        </b-taglist>
      </div>
    </div>
    <b-modal :active.sync="isCardModalActive" style="width=729; height=425;">
      <div class="altura-full">
        <div class="card-content altura-full">
          <iframe class="altura-full" allowfullscreen width="100%" height="100%" v-bind:src="video_url"></iframe>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

export default {
  name: "Video",
  data() {
    return {
      video_url: "",
      img_url: "",
      id: "",
      isImageModalActive: false,
      isCardModalActive: false
    };
  },
  props: ["video"],
  created() {
    if(this.video.url.toLowerCase().indexOf("youtube") >= 0){
      this.id = this.video.url.match(/youtube\.com.*(\?v=|\/watch\/)(.{11})/).pop();
      this.video_url = "//www.youtube.com/embed/" + this.id;
      this.img_url = "//img.youtube.com/vi/"+this.id+"/0.jpg";
    }else{

      let videoId = this.video.url.split("/")[2];

      this.video_url = 'https://player.vimeo.com/video/'+ videoId; //return a iframe
      
      let Vimeo = require('vimeo').Vimeo;

      var CLIENT_ID = "e497d8839f1f561852c70ca7b51f5d839e2881ca"
      var CLIENT_SECRET = "ba2YlmG+LF+AhMleWvRrvKcdZaFUSCsUEaatyX+oihMJG8BzHgxCU12VaJJ5Rv5K3n+rRHx2mjuiniG3WnqBuH+fQDIXfRMqhrkHx/k5wt2yjJVec5YhQDmVfA7y1hc2"
      var ACCESS_TOKEN = "76e93d83d363519cf021fd32f8fda8d8"
      var client = new Vimeo(CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN);

      var self = this; // Vue instance

      client.request({
        method: 'GET',
        path: 'videos/' + videoId + '/pictures'
      }, 
      function (error, body, status_code, headers) {
        if (!error) {
          self.img_url = body.data[0].sizes[3].link;
        } 
        //to avoid vue warning
        error;
        status_code;
        headers;
      });
    }
  }
};
</script>
<style scoped>
.card-video {
  background-color: #f4d58e;
  padding: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.1);
}
.dercricao-video {
  margin: -10px;
  border-radius: 10px;
  padding: 10px;
  background-color: #fff;
}
img.thumbnail-video {
  border-radius: 10px 10px 0 0;
  padding-bottom: 3px;
}
span.rigth.is-dark.is-top.is-medium.b-tooltip {
  float: right;
  top: -25px;
}
.dercricao-video h1 {
  font-weight: bold;
  text-transform: capitalize;
}

.dercricao-video h2::first-letter {
  text-transform: capitalize;
}
.dercricao-video h2 {
  text-align: justify;
}
.tag-video {
  background-color: #ea5b04 !important;
}
.modal.is-active .animation-content, .altura-full{
  height: 100% !important;
}
</style>